import { queryOptions } from '@tanstack/react-query';

import { organizationsControllerFindOne } from '@/api/core-api';
import { getClient } from '@/utils/get-api-client';

import { queryKeys } from './query-keys';

/**
 * Query options for fetching an organization by ID.
 * Can be used directly with useQuery or for prefetching.
 */
export const organizationQueryOptions = (
  organizationId: string,
  authUserId?: string,
) =>
  queryOptions({
    queryKey: queryKeys.organizations.detail(organizationId),
    queryFn: () =>
      organizationsControllerFindOne({
        client: getClient(authUserId),
        path: { organizationId },
        throwOnError: true,
      }).then((res) => res.data),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

/**
 * Whether the organization may use AI (`features['ai-opted-out']` is not
 * `true`). Same cache entry as `organizationQueryOptions`. `data` is
 * `undefined` while loading, on a failed read and without an organization, so
 * `data === true` / `data = false` fails closed. Note `select` does not run
 * in `ensureQueryData`; route readers apply the check on the raw organization.
 */
export const organizationCanUseAiQueryOptions = (
  organizationId: Maybe<string>,
  authUserId?: string,
) =>
  queryOptions({
    ...organizationQueryOptions(organizationId ?? '', authUserId),
    enabled: !!organizationId,
    select: (organization) => organization?.features?.['ai-opted-out'] !== true,
  });
